import React, { useEffect, useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import { read } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import Translator from "Languages/Utility/Translator";
import { changeMahdoodeSearch, DeleteMahdoode } from "Stores/actions";
import { SAVE_MAHDOODE_DATA } from "Stores/actionTypes";
import * as Icons from 'react-bootstrap-icons';

function DeleteYaragh({ row }) {
  const {
    dataRelationRokob,
    selectedBrandYaragh,
    mahdoodeData,
    mahdoodeDataPagination,
    isWidth,
    isHeight,
  } = useSelector((state) => ({
    dataRelationRokob: state.rokub.dataRelationRokob,
    selectedBrandYaragh: state.yaragh.selectedBrandYaragh,
    mahdoodeData: state.yaragh.mahdoodeData,
    mahdoodeDataPagination: state.yaragh.mahdoodeDataPagination,
    isWidth: state.yaragh.isWidth,
    isHeight: state.yaragh.isHeight,
  }));
  const [showAlert, setShowAlert] = useState(false);
  const [deleteRelationData, setDeleteRelationData] = useState(null);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onShowAlert = () => {
    setShowAlert(!showAlert);
    setDeleteRelationData(null);
  };

  const onDelete = async () => {
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: row.Id,
      };
      const res = await dispatch(DeleteMahdoode(data));
      if (res) {
        onShowAlert();
        dispatch({
          type: SAVE_MAHDOODE_DATA,
          mahdoodeData: mahdoodeData.filter((item) => item.Id !== row.Id),
          mahdoodeDataPagination: mahdoodeDataPagination,
          isWidth: isWidth,
          isHeight: isHeight,
        });
        dispatch(changeMahdoodeSearch({ Name: "" }));
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    setDeleteRelationData(dataRelationRokob);
  }, [dataRelationRokob]);

  return (
    <>
      <ActionFormatter
        title={<Translator id="hazf" />}
        icon={<Icons.Trash3 size={17} />}
        className="danger-fill"
        onClick={onShowAlert}
        disabled={
         ( selectedBrandYaragh
              ? selectedBrandYaragh.Disable
              : true) ||
          (row.IsG &&
              read("StypeU") !== "1") ||
              read("yaraghRules")?.accessDelete === false
        }

      />
      <AlertDialog
        showAlert={showAlert}
        type="alertError"
        onClose={onShowAlert}
        onClickOk={onDelete}
        okTitle={<Translator id="ble_pak_shavad" />}
        cancelTitle={<Translator id="enseraf" />}
        questionText={<Translator id="aya_az_hazf_an_etminan_darid" />}
        relationText={<Translator id='relationAlert' />}
        relationData={deleteRelationData}
        loading={loading}
      />
    </>
  );
}
export default DeleteYaragh;
